export enum ChartType {
    PieChart = "pie-chart",
    DonutChart = "donut-chart",
    BarChart = "bar-chart",
    StackedBarChart = "stacked-bar-chart",
}
